export default "__VITE_ASSET__BLkl9xM9__"